<div class="search-container" (click)="$event.stopPropagation()">
  <input type="text" placeholder="Rechercher..." class="search-input" [(ngModel)]="value" [style.width.px]=" isSearchOpen ? width : 0"
    [ngClass]="{'open': isSearchOpen}" (keyup)="applyFilter($event)" (blur)="handleBlur()" #searchInput>
  <mat-icon *ngIf="!value" (click)="toggleSearch(); searchInput.focus()" class="search-icon">search</mat-icon>
  <mat-icon *ngIf="value" (click)="clearSearch()" class="search-icon">close</mat-icon>
</div>